module.exports = __webpack_public_path__ + "static/media/billabong.fd29034c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/billabong.png
// module id = 264
// module chunks = 0